module.exports = __webpack_public_path__ + "static/media/Image_simple.6ac1a30b.svg";